import React from "react";
import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useVehicleFuelDetailContext, VehicleFuelDetailContext } from "contexts/VehicleFuelDetailContext";
import { useGetVehicleFuelDetailQuery, useUpdateVehicleFuelMutation } from "store/services/vehicleFuelApi";

import VehicleFuelBasicDetail from "./VehicleFuelComponents/VehicleFuelBasicDetail";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EnableDisableButton from "components/Shared/EnableDisableButton";
import { useAuth } from "hooks";

const VehicleFuelDetailScreen = () => {
  const { id } = useParams();

  const breadcrumb = [
    { title: "Vehicle Fuel", path: "/app/crm/vehicle-fuel/list" },
    { title: "Vehicle Fuel Detail" },
  ];

  // RTK Query
  const {
    data: vehicleFuelDetail,
    isLoading: loadingVehicleFuel,
    error,
  } = useGetVehicleFuelDetailQuery(id);

  return (
    <VehicleFuelDetailContext.Provider value={{ vehicleFuelDetail, loadingVehicleFuel }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumb}
        isBusy={loadingVehicleFuel}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <VehicleFuelBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </VehicleFuelDetailContext.Provider>
  );
};

export default VehicleFuelDetailScreen;

const PageActions = () => {
  const { isAccountAdmin } = useAuth();

  const { vehicleFuelDetail, loadingVehicleFuel } = useVehicleFuelDetailContext();

  // RTK Query
  const [updateVehicleFuel, { isLoading: updatingVehicleFuel }] = useUpdateVehicleFuelMutation();

  // Methods
  const handleToggleFuelStatus = async () => {
    try {
      await updateVehicleFuel({
        _id: vehicleFuelDetail._id,
        isActive: !vehicleFuelDetail.isActive,
      }).unwrap();
      toast.info(`Fuel record ${vehicleFuelDetail.isActive ? "Disabled" : "Enabled"}!`);
    } catch (error) {
      toast.error(error?.data?.message ?? "Could Not Update Status");
    }
  };

  return (
    <div className="flex space-x-4">
      {isAccountAdmin &&(<EnableDisableButton
        isActive={vehicleFuelDetail?.isActive}
        loading={loadingVehicleFuel || updatingVehicleFuel}
        onClick={handleToggleFuelStatus}
      />)}
      <Link to={`/app/crm/vehicle-fuel/${vehicleFuelDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};